import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,{staticClass:"my-2"},[_c(VCardText,{staticClass:"text-h5"},[_c(VRow,[_c(VCol,{attrs:{"cols":"auto"}},[_c('span',{staticClass:"text-overline"},[_vm._v(_vm._s(_vm.sectionDisplay))])]),_c(VSpacer),_c(VCol,{attrs:{"cols":"auto"}},[_c(VCheckbox,{attrs:{"hide-details":""},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }